/**
 * Runtime Types
 * Workspace runtime entries (for runtime service).
 */

import { z } from 'zod';

export const WorkspaceOwnerInfoSchema = z.object({
  ownerId: z.string(),
  ownerName: z.string().optional(),
  ownerEmail: z.string().optional(),
  ownerProfilePictureUrl: z.string().optional(),
});

export type WorkspaceOwnerInfo = z.infer<typeof WorkspaceOwnerInfoSchema>;

export const WorkspaceRuntimeEntrySchema = z.object({
  workspaceId: z.string(),
  path: z.string(),
  name: z.string().optional(),
  owner: WorkspaceOwnerInfoSchema.optional(),
  isOwner: z.boolean().optional(),
});

export type WorkspaceRuntimeEntry = z.infer<typeof WorkspaceRuntimeEntrySchema>;
